// src/components/Footer.jsx
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: '#000', color: '#fff' }} className="py-5">
      <Container>
        <Row>
          {/* Google Maps */}
          <Col md={6} className="mb-4">
            <h5 className="mb-3">Nossa Localização</h5>
            <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
              <iframe
                title="Barber Shop Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3392.3214159634467!2d-52.32765860000001!3d-31.7617184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9511b5b02767a125%3A0xfabff14fa6ddc524!2sAv.%20Ferreira%20Viana%2C%20723%20-%20Cruzeiro%20do%20Sul%2C%20Pelotas%20-%20RS%2C%2096085-000!5e0!3m2!1spt-BR!2sbr!4v1747769099603!5m2!1spt-BR!2sbr"
                width="100%"
                height="250"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              />
            </div>
          </Col>

          {/* Hours & Contact */}
          <Col md={6}>
            <Row>
              <Col xs={12} sm={6} className="mb-4">
                <h5 className="mb-3">Horário de Atendimento</h5>
                <ul className="list-unstyled">
                  <li>Segunda - Sexta: 8:00 – 20:00</li>
                  <li>Sábado: 8:00 – 20:00</li>
                  <li>Domingo: Fechado</li>
                </ul>
              </Col>
              <Col xs={12} sm={6} className="mb-4">
                <h5 id='contact' className="mb-3">Contato</h5>
                <p className="mb-2">
                  <strong>Telefone:</strong><br/>
                  <a href="tel:+5553984339680" style={{ color: '#fff', textDecoration: 'none' }}>
                    +(53)984339680
                  </a>
                </p>
                <p>
                  <strong>Email:</strong><br/>
                  <a href="mailto:avilabarber727@gmail.com" style={{ color: '#fff', textDecoration: 'none' }}>
                    avilabarber727@gmail.com
                  </a>
                </p>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr style={{ borderColor: 'rgba(255,255,255,0.2)' }} />

        <Row>
          <Col className="text-center">
            <small>© {new Date().getFullYear()} Barbearia Ávila. Todos os direitos reservados.</small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
